import { Component, OnInit } from '@angular/core';
import { CoreCardBaseComponent } from '../shared/core-card-base.component';

@Component({
  selector: 'cu-dynamic-card',
  templateUrl: './dynamic-card.component.html'
})
export class DynamicCardComponent extends CoreCardBaseComponent implements OnInit {
  public ngOnInit(): void {}
}
